import { Link } from "@tanstack/react-router";
import { useDrawer } from "hooks/useDrawer";
import { DrawerId } from "types/models.ts";

export interface DrawerLinkProps {
    drawerId: DrawerId;
    action?: "show" | "hide" | "toggle";
    children: React.ReactNode;
    to?: string;
    search?: Record<string, string>;
    disabled?: boolean;
}

export const DrawerLink = ({
    drawerId,
    action = "toggle",
    children,
    search = {},
    ...props
}: DrawerLinkProps): React.JSX.Element => {
    const drawerUtils = useDrawer();

    const handleClick = (e: React.MouseEvent<unknown, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        if (action === "toggle") {
            drawerUtils.toggle(drawerId, search);
        } else if (action === "show") {
            drawerUtils.show(drawerId, search);
        } else if (action === "hide") {
            drawerUtils.hide(drawerId);
        }
    };

    // TODO - cant see link, open in new tab doesnt work
    return (
        <Link replace={false} {...props} onClick={handleClick}>
            {children}
        </Link>
    );
};
